<div class="order-info-body-preview">
	<div class="details">
		<div class="details-left">
			<div class="detail">
				<span
					highlight
					class="value"
					[isPositive]="order?.side === orderSideEnum.BUY"
					[isNegative]="order?.side === orderSideEnum.SELL"
					>{{ 'ordersInfo.side.' + order?.side | translate }}</span
				>
				@if (order) {
					<span class="value">{{ order | titleOrderType }}</span>
				}
				@if (order) {
					<span class="value">
						{{
							'ordersInfo.terms.' + (order.time_in_force | titleOrderTerm: order.extended_hours)
								| translate
						}}
					</span>
				}
			</div>
		</div>
		<div class="details-right">
			<div class="detail">
				<span class="value"> {{ order?.qty | quantity }} {{ 'ordersInfo.pcs' | translate }}</span>
				@if (order?.type === orderTypeEnum.STOP_LIMIT) {
					<div class="detail">
						<span class="value">S: {{ order?.stop_price | price }} </span>
					</div>

					<div class="detail">
						<span class="value">L: {{ order?.limit_price | price }} </span>
					</div>
				} @else {
					<span class="value">
						@if (order?.type === orderTypeEnum.LIMIT) {
							{{ order?.limit_price | price }}
						}

						@if (order?.type === orderTypeEnum.STOP) {
							{{ order?.stop_price | price }}
						}
					</span>
				}
			</div>
		</div>
	</div>
</div>
